import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import { LANGUAGE } from 'constants/index'
import getLanguage from 'utils/getLanguage'

import enTranslation from './assets/locales/en.json'
import zhCnTranslation from './assets/locales/zh-CN.json'
import zhTwTranslation from './assets/locales/zh-TW.json'
import koTranslation from './assets/locales/ko.json'

const resources = {
  [LANGUAGE.EN]: {
    translation: enTranslation,
  },
  [LANGUAGE.ZH_CN]: {
    translation: zhCnTranslation,
  },
  [LANGUAGE.ZH_TW]: {
    translation: zhTwTranslation,
  },
  [LANGUAGE.KO]: {
    translation: koTranslation,
  },
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources,
    lng: getLanguage(),
    fallbackLng: LANGUAGE.EN, // 如果當前切換的語言沒有對應的翻譯則使用這個語言，
    interpolation: {
      escapeValue: false,
    },
    nsSeparator: false,
    keySeparator: false,
  })

export default i18n
